
import { Filter } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuCheckboxItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ActivityType, PatrolFilters } from './types';

interface FilterBarProps {
  filters: PatrolFilters;
  onFiltersChange: (filters: PatrolFilters) => void;
}

const ACTIVITY_TYPES: ActivityType[] = ['patrol_start', 'patrol_end', 'checkpoint', 'incident', 'alert'];
const STATUS_OPTIONS = ['active', 'completed', 'pending', 'resolved'];

export const FilterBar = ({ filters, onFiltersChange }: FilterBarProps) => {
  const handleTypeToggle = (type: ActivityType) => {
    const types = filters.types.includes(type)
      ? filters.types.filter(t => t !== type)
      : [...filters.types, type];
    onFiltersChange({ ...filters, types });
  };

  const handleStatusToggle = (status: string) => {
    const statuses = filters.status.includes(status)
      ? filters.status.filter(s => s !== status)
      : [...filters.status, status];
    onFiltersChange({ ...filters, status: statuses });
  };

  return (
    <div className="flex items-center gap-4 mb-4">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="gap-2">
            <Filter className="h-4 w-4" />
            Activity Type
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {ACTIVITY_TYPES.map(type => (
            <DropdownMenuCheckboxItem
              key={type}
              checked={filters.types.includes(type)}
              onCheckedChange={() => handleTypeToggle(type)}
            >
              {type.replace('_', ' ')}
            </DropdownMenuCheckboxItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="gap-2">
            <Filter className="h-4 w-4" />
            Status
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {STATUS_OPTIONS.map(status => (
            <DropdownMenuCheckboxItem
              key={status}
              checked={filters.status.includes(status)}
              onCheckedChange={() => handleStatusToggle(status)}
            >
              {status}
            </DropdownMenuCheckboxItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>

      <Input
        placeholder="Filter by guard name..."
        value={filters.guardName}
        onChange={(e) => onFiltersChange({ ...filters, guardName: e.target.value })}
        className="max-w-[200px]"
      />
    </div>
  );
};
